import { trackEvent } from './google-tag-manager';

export default function openFeedback() {
  trackEvent('open-feedbackify');
  (window as any).fby.push(['showForm', '15587']);
}
